<template>
  <div :class="{'mobile-menu' : $tvaMq === 'mobile'}">
    <transition name="fade">
      <div class="eni-for-modal" v-if="show" @click="show=false"></div>
    </transition>
    <transition name="slide">
      <div class="eni-for-menu" v-if="show">
        <div class="eni-for-menu-content">
          <div class="close-menu" v-if="$tvaMq !== 'mobile'" @click="show=false">
            <svgicon icon="close" width="32" height="32"></svgicon>
          </div>
          <div class="close-menu-mobile" v-if="$tvaMq === 'mobile'" @click="show=false">
            <svgicon icon="close-plain" width="18" height="18"></svgicon>
          </div>
          <div class="tva-lang-switch">
            <a
              :class="['lang', $ml.current === lang ? 'selected' : '']"
              v-for="lang in $ml.list"
              :key="lang"
              :href="lang === 'IT' ? 'https://www.eni.com/dist/infografiche/eni-for-2018/index.html' : 'https://www.eni.com/dist/infographics/eni-for-2018/index.html'"
            >{{$ml.get("landing")[lang]}}</a>
          </div>
          <div class="eni-for-menu-section casina">
            <svgicon icon="casina" width="34" height="34"></svgicon>
            <router-link :to="{name: 'home'}">{{$ml.get('landing').home}}</router-link>
          </div>
          <div class="eni-for-menu-section chapters">
            <div
              class="chapter-block"
              v-for="(chapter, chapterIndex) in $ml.get('chapters')"
              :key="chapterIndex"
            >
              0{{chapterIndex+1}}
              <router-link :to="{name: 'chapter', params: {chapterIndex}}">{{chapter.title}}</router-link>
              <ul v-if="$tvaMq !== 'mobile'">
                <li v-for="(segment, segmentIndex) in chapter.sections" :key="segmentIndex">
                  <router-link
                    :to="{name: 'chapter', hash: `#section-${slug(segment.id)}`, params: {chapterIndex}}"
                  >{{segment.title}}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="eni-for-menu-section">
            <svgicon icon="download-arrow" width="16" height="16"></svgicon>
            <router-link :to="{name: 'documents'}">{{$ml.get('landing').pubblicazioni}}</router-link>
          </div>
          <div class="eni-for-menu-section">
            <svgicon icon="star" width="14" height="14"></svgicon>
            <router-link :to="{name: 'eni_numeri'}">{{$ml.get('landing').eni_numeri}}</router-link>
          </div>
        </div>
        <social-sharing
          :url="$ml.get('landing').url"
          title="Eni for 2018"
          :description="$ml.get('landing').subtitle"
          quote
          hashtags
          twitter-user
          inline-template
        >
          <div class="share-mobile" v-if="$tvaMq === 'mobile'">
            <svgicon icon="share" width="14" height="14"></svgicon>
            <network network="facebook" class="no-border">Facebook</network>
            <network network="linkedin">Linkedin</network>
            <network network="twitter">Twitter</network>
          </div>
        </social-sharing>
      </div>
    </transition>
  </div>
</template>
<script>
import "@/compiled-icons/close";
import "@/compiled-icons/share";
import "@/compiled-icons/close-plain";
import "@/compiled-icons/casina";
import "@/compiled-icons/download-arrow";
import "@/compiled-icons/star";
import slugify from "slugify";

export default {
  data() {
    return {
      show: false,
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    slug(string) {
      if (string) {
        return slugify(string, {
          lower: true,
          remove: "'"
        });
      } else {
        return "";
      }
    }
  },
  created() {
    this.$menuHub.$on("toggle-menu", action => {
      this.show = !this.show;
    });
    this.$menuHub.$on("close-menu", action => {
      this.show = false;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/buttons.scss";
a {
  position: relative;
  padding-right: 10px;
  font-size: 14px;
  font-family: "Avenir Next";
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.4px;
  &:after {
    content: "";
    width: 0;
    height: 100%;
    background: rgba($eni-yellow, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all 0.5s ease;
  }
  &:hover {
    color: black;
    &:after {
      width: 100%;
    }
  }
}
li {
  height: fit-content;
  color: $eni-grey;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translate(-100%, 0);
}
.slide-leave,
.slide-leave-to {
  transform: translate(-100%, 0);
}
.eni-for-modal {
  position: fixed;
  background: rgba(black, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;
}
.eni-for-menu {
  z-index: 1000;
  position: fixed;
  background: white;
  height: 100vh;
  top: 0;
  padding: 8vh 8vw 0 8vw;
  font-family: "Avenir Next";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: normal;
  color: $eni-grey;
  margin: 0;
  .eni-for-menu-content {
    position: relative;
    .close-menu-mobile {
      display: inline-block;
      position: fixed;
      left: 25px;
      top: 15px;
      .svg-icon {
        fill: inherit;
      }
    }
    .tva-lang-switch {
      position: fixed;
      top: 12px;
      right: 10px;
      a {
        color: #000;
        &.selected {
          font-weight: 700;
        }
      }
    }
    .close-menu {
      cursor: pointer;
      display: inline-block;
      position: absolute;
      left: -5.5vw;
      top: -3em;
      cursor: pointer;
      .svg-icon {
        fill: $eni-grey;
      }
    }
    .eni-for-menu-section {
      border-bottom: 1px solid;
      padding: 1em 0;
      &:last-child {
        border-bottom: none;
      }
      &.chapters {
        text-transform: uppercase;
        font-weight: 600;
        padding-top: 0;
        .chapter-block {
          margin-top: 20px;
          ul {
            margin-top: 10px;
            li {
              margin: 0.2em 0;
              a {
                text-transform: none;
              }
            }
          }
          a {
            border-left: 1px solid;
            padding-left: 0.5em;
            margin-left: 0.2em;
          }
        }
      }
      &:not(.chapters) {
        display: flex;
        align-items: center;
        .svg-icon {
          margin-right: 0.5em;
        }
        a {
          text-transform: capitalize;
        }
      }
      &.casina {
        padding-top: 0;
        .svg-icon {
          margin-right: 0.1em;
          fill: white;
          stroke: black;
        }
      }
      a {
        text-decoration: unset;
        color: inherit;
        margin-top: 4px;
      }
      ul {
        li {
          list-style: none;

          a {
          }
        }
      }
    }
  }
}
.mobile-menu {
  .eni-for-menu {
    width: 100vw;
    height: 100vh;
    padding: 15vh 8vw 0 8vw;
    .eni-for-menu-content {
      .eni-for-menu-section {
        border-bottom: 1px solid;
        padding-bottom: 2em;
        &.chapters > div:not(:last-child) {
          margin-bottom: 1em;
        }
        &:last-child {
          border: none;
        }
      }
    }
  }
}
@media (max-width: 720px) {
  a {
    &:after {
      content: none;
      pointer-events: none;
    }
    &:hover {
      color: unset;
      &:after {
        width: 0;
        pointer-events: none;
      }
    }
  }
  .eni-for-menu {
    .eni-for-menu-content {
      .eni-for-menu-section {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
        &.chapters {
          padding-top: 0 !important;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "../assets/scss/colors.scss";
@import "../assets/scss/buttons.scss";
.share-mobile {
  margin-top: 4em;
  color: lightgray;
  display: flex;
  align-items: center;
  width: 100%;
  .svg-icon {
    fill: lightgray;
  }
  span {
    margin: 0.3em;
    padding: 0.2em 0.5em 0.2em 0.1em;
    &:not(:last-child) {
      border-right: 1px solid;
    }
  }
}
</style>

